import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as CheckboxComponent, FormControlLabel } from '@material-ui/core';
import { CheckboxIcon } from '../Icons';

const Checkbox = ({ value, label, children, classes, checked, disabled, ...props }) => {
  return (
    <FormControlLabel
      label={label || children}
      classes={{
        root: classes.labelRoot,
        label: classes.label,
        disabled: classes.disabled,
      }}
      control={
        <CheckboxComponent
          checked={checked}
          classes={{ root: classes.root }}
          icon={<span className={classes.icon} />}
          checkedIcon={<CheckboxIcon className={classes.checkedIcon} />}
          color="default"
          value={value}
        />
      }
      disabled={disabled}
      {...props}
    />
  );
};

Checkbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The value of the component. */
  value: PropTypes.string,
  /** The text to be used in an enclosing label element. */
  label: PropTypes.node,
  /** The content that will be rendered as label. */
  children: PropTypes.node,
  /** If true, the component appears selected. */
  checked: PropTypes.bool,
  /** If true, the control will be disabled. */
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  classes: {},
  value: '',
  label: null,
  children: null,
  checked: false,
  disabled: false,
};

export default Checkbox;
